import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('OnTopOfConnector', () => ({
  root: {
    zIndex: 1,
  },
}));

// When you use a BottomUpConnector, it goes on top of everything because it's position:absolute.
// To get something on top of the BottomUpConnector, wrap it with this component
export function OnTopOfConnector({ children }) {
  const classes = useStyles();
  return (
    <div className={classes.root}>{children}</div>
  );
}

OnTopOfConnector.propTypes = {
  children: PropTypes.node.isRequired,
};
